"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;
const effect_1 = require("effect");
exports.join = effect_1.Function.dual(2, (strings, separator) => strings.join(separator));
//# sourceMappingURL=string.js.map